<template>
  <div class="uploadbox" :class="{ editfile: edit }">
    <FileSee ref="FileSee" :info="info"></FileSee>
    <drag-modal :visible="visible" @cancel="visible = false" title="修改附件名称" width="480px" :zIndex="10001">
      <div class="selectbox">
        <div class="lf">
          <div class="input">
            <label>附件名称：</label>
            <a-input placeholder="请输入附件新名称" style="width: 190px" v-model="file.title">
            </a-input>
          </div>
        </div>
        <div class="btns">
          <a-button type="primary" icon="check-circle" @click="setName">确定修改</a-button>
        </div>
      </div>
    </drag-modal>
    <div class="clearbox">
      <div class="input">
        <label :style="{ width: Wid }">
          <font color='#f00' v-if='repuired'>*</font>
          附件上传：
        </label>
        <div class="btn" v-if="!edit">
          <span>上传 </span>
          <input type="file" @change="handlePreview($event)" multiple accept="*" id="files" />
        </div>
      </div>
    </div>
    <a-spin :spinning="spinning" tip="上传中">
      <div class="table" v-if="fileList.length > 0">
        <div style="display: flex;justify-content: end;padding-right: 20px;margin-bottom: 12px;margin-top: -12px;"
          v-if="Allshow">
          <a-button icon="search" type="primary" ghost @click='Preview()'>预览</a-button>
        </div>
        <table style="table-layout: auto">
          <thead>
            <td width='20'></td>
            <td width="60px" style="white-space: nowrap">序号</td>
            <td width="240px">文件名</td>
            <td width="120px" style="white-space: nowrap">上传进度</td>
            <td width="100px">操作</td>
          </thead>
          <tbody>
            <tr v-for="(i, index) in fileList" :key="index" :class="{ editing: i.audit }">
              <td>
                <input type="checkbox" :disabled="i.disabled" v-model='i.checked' @change="outCK(i)" />
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                <div class="title" :alt="i.title || i.origin_name">
                  <div class="norap">
                    <Normap :tit="i.title || i.origin_name"></Normap>
                  </div>
                  <a-button type="link" @click="
                    file = JSON.parse(JSON.stringify(i))
                  file.index = index
                  visible = true
                    " v-if="!disabled && ($store.getters.debInfo.is_clear != 1 && $store.state.cause.invaild != 1 && power ? power.edit : true)
                    ">修改
                  </a-button>
                </div>
              </td>
              <td>

                <div class="cbown" style="white-space: nowrap">
                  <a-progress :percent="i.progress * 1" size="small" style="width: 160px"
                    v-if="i.status <= 1 && i.progress < 100" />
                  <!-- <a-progress :percent="100" size="small" style="width:160px;" status="exception" v-else /> -->
                  <span class="status succ" v-if="i.status == 1">上传成功</span>
                  <span class="status err" v-if="i.status == 2">上传失败</span>
                  <span class="status ing" v-if="i.status == 0">上传中</span>
                  <span class="status ing" v-if="i.progress == 0 && i.status == 0">等待上传</span>
                </div>
              </td>
              <td style="white-space: nowrap">
                <a href="javascript:void(0);" class="see" v-if="Filetype(i.url) == 3">
                  <viewer class="pimg"><img v-for="(decImg, ind) in imgList" :key="ind" :src="decImg.url"
                      style="width: 100%; height: 100%" :class="{ fir: decImg.index == index }" /> </viewer>浏览
                </a>
                <a href="javascript:void(0);" class="see" @click="see(i)" v-else>浏览</a>
                <span class="line" v-if="!edit && !i.audit"></span>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del(index, i)">
                  <a href="javascript:void(0);" v-if="!edit && !i.audit && (power ? power.del : true)">删除</a>
                </a-popconfirm>
                <span class="line" v-if="power ? power.down : true"></span>
                <!-- <a-popconfirm title="确认下载图片吗?" ok-text="确定" cancel-text="取消" @confirm='download()'> -->
                <a :href="downFile(i)" target="_blank" :download="i.title || i.origin_name"
                  v-if="power ? power.down : true">下载</a>
                <!-- </a-popconfirm> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-spin>
    <drag-modal :width='dragModalwidth' :visible="visible1" @cancel="() => visible1 = false" :title='notificationtitle'
      :zIndex='10001'>
      <!-- <a :href="downFile(info)" target="_blank" class="down">下载</a> -->
      <div style="display: flex;gap: 10px;justify-content: space-between;width: 100%;">
        <iframe v-for="item in notificationLsit" :key="item.id" :src="item.url" frameborder="0" :width="dragModalwidth"
          height='600'></iframe>
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { rFileName } from '@/server/api'
import $http from 'superagent'
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from '@/components/filesee'
import { Filetype } from '@/assets/js/unit'
import { mapGetters } from 'vuex'
import { delFiles } from '@/server/debtor'
export default {
  props: {
    disabled: Boolean,   //保全记录 不需要修改
    call: Boolean,
    repuired: Boolean,
    power: Object,
    isHis: Number,
    Wid: String,
    fList: {
      type: Array,
      default() {
        return []
      },
    },
    edit: Boolean,
  },
  data() {
    return {
      file: {},
      spinning: false,
      visible: false,
      fileList: [],
      info: {}, //查看详情
      notificationLsit: [],
      Allshow: false,
      notificationtitle: '',
      dragModalwidth: '',
      visible1: false
    }
  },
  watch: {
    fList: {
      handler(val) {
        if (val) {
          this.fileList = JSON.parse(JSON.stringify(this.getUrl(val)))
          this.fileList = this.fileList.map(ele => {
            // 如果 Filetype(ele.url) 不等于 2，则设置 disabled 为 true
            if (Filetype(ele.url) == 2) {
              ele.disabled = false;
            } else {
              ele.disabled = true;
            }
            return ele;
          });
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapGetters(['Edit', 'DisForm']),
    imgList() {
      if (this.fileList) {
        let fileList = JSON.parse(JSON.stringify(this.fileList))
        fileList.map((ele, index) => {
          ele.index = index
        })
        return fileList.filter((ele) => {
          return Filetype(ele.url) == 3
        })
      } else {
        return []
      }
    },
  },
  components: {
    FileSee,
  },
  // created() {
  //   if (this.fList.length > 0) {
  //     //判断是否有默认值
  //     this.fileList = this.getUrl(this.fList)
  //   }
  // },
  methods: {
    Preview() {//预览
      this.visible1 = true
      if (this.notificationLsit[1]) {
        this.notificationtitle = this.notificationLsit[0].title + ' / ' + this.notificationLsit[1].title;
        this.dragModalwidth = '80%'
      } else {
        this.dragModalwidth = '740px'
        this.notificationtitle = this.notificationLsit[0].title;
      }
    },
    outCK(currentItem) {   //单选
      let ids = {}
      const checkedCount = this.fileList.reduce((c, i) => c + (i.checked ? 1 : 0), 0);
      if (checkedCount > 1) {
        // 1. 先将所有项的 disabled 设为 true
        this.fileList.forEach(item => {
          if (item.id == currentItem.id) {
            ids = currentItem
          }
          item.disabled = true;
        });
        this.notificationLsit.push(ids)
        // 2. 再将已选中的两项的 disabled 设回 false
        this.fileList.filter(item => item.checked)
          .slice(0, 2)  // 只保留前两个选中的
          .forEach(item => {
            item.disabled = false;
          });
        return;
      }
      // 如果不超过2个，重置所有 disabled 为 false
      this.fileList = this.fileList.map(ele => {
        // 如果 Filetype(ele.url) 不等于 2，则设置 disabled 为 true
        if (Filetype(ele.url) == 2) {
          ele.disabled = false;
        } else {
          ele.disabled = true;
        }
        return ele;
      });
      this.notificationLsit = this.fileList.filter(i => i.checked);
      this.Allshow = this.notificationLsit.length > 0;
    },
    downFile(i) {
      const baseUrl = process.env.NODE_ENV == "development" ? "https://demo.dyuit.cn/xiaoyin/index.php/api/" : Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.url)}&filename=${encodeURIComponent(i.title || i.origin_name)}`
    },
    Filetype,
    setName() {
      rFileName({
        upload_id: this.file.upload_id || this.file.id,
        title: this.file.title,
      }).then((e) => {
        this.$message.success({ content: '修改成功' })
        this.fileList[this.file.index].title = this.file.title
        if (this.call) {
          this.$store.dispatch('Debinfo/getInfo', { id: this.$route.params.id })
        }
        this.visible = false
      })
    },
    del(index, item) {
      //删除
      if (item.audit) return false
      let list = JSON.parse(JSON.stringify(this.fileList))
      if (this.Edit && item.step_id) {
        //修改时删除
        delFiles({
          step_id: item.step_id,
          ids: [item.id],
        }).then((e) => {
          this.$message.success({ content: '已提交审核', key: 'updatable' })
          list[index].audit = {
            action: 'del',
          }
          this.fileList = list
        })
      } else {
        list.splice(index, 1)
        this.fileList = list
      }

      this.$emit('upFileAfter', this.mpFilterList(list))
    },
    getUrl(Arr) {
      Arr.map((ele) => {
        ele.progress = 100
        ele.status = 1 //0 上传中 1 上传成功 2上传失败
        ele.hasUpload = true //  初始设置已上传过 后续过滤
      })
      return Arr
    },
    async beforeUpload(file, fileList) {
      // console.log(file);
      for (let i = 0, f; (f = file[i]); i++) {
        fileList.unshift({
          title: f.name,
          progress: 0,
          status: 0,
          hasUpload: false,
        })
      }
      this.fileList = fileList
      this.$emit('upFileAfter', null)
      this.spinning = true
    },
    async uploading(file, fileList) {
      let Put = (f, i) => {
        return new Promise((resolve, reject) => {
          $http
            .post(Tacitly.Base_Port + 'upload/file')
            .set('Authorization', localStorage.getItem("t"))
            .attach('file', f)
            .on('progress', (event) => {
              let direction = event.direction == 'upload' ? event.percent : 100
              fileList[i].progress = Number(direction).toFixed(0)
              fileList[i].status = 0
              this.$set(this.fileList, i, fileList[i])
            })
            .then((res) => {
              let data = res.body.data
              fileList[i].progress = 100
              if (res.body.code == '0000') {
                fileList[i].upload_id = data.id
                fileList[i].url = data.url
                fileList[i].title = data.origin_name
                fileList[i].status = 1
                fileList[i].disabled = Filetype(data.url) == 2 ? false : true
                this.$set(this.fileList, i, fileList[i])
              } else {
                this.$message.error({ content: res.body.msg, key: 'updatable' })
                this.spinning = false;
                fileList[i].disabled = true
                fileList[i].status = 2
              }
            })
            .catch((err, res) => {
              fileList[i].progress = 100
              fileList[i].status = 2
              this.$set(this.fileList, i, fileList[i])
              this.spinning = false;
            })
            .then((e) => {
              // this.$refs.files.setAttribute('value', '');
              document.getElementById('files').value = ''
              resolve('over')
            })
        })
      }
      let newFileList = []
      for (let i = 0, f; (f = file[i]); i++) {
        newFileList.push(file[i])
      }

      let getAll = async () => {
        let result = await Promise.all(
          newFileList.map((ele, index) => {
            return Put(ele, index)
          })
        )
        return result
      }
      getAll().then((result) => {
        let list = JSON.parse(JSON.stringify(this.fileList))
        let nlist = this.mpFilterList(list)
        this.$emit('upFileAfter', nlist)
        this.spinning = false;
      })
    },
    mpFilterList(list) {
      // console.log(list)
      let newlist = list
        .filter((ele) => {
          return ele.status == 1
        })
        .map((ele) => {
          return ele.upload_id || ele.id
        })
      return newlist
    },
    async handlePreview(file) {
      //上传图片
      let files = file.target.files
      let fileList = this.fileList
      await this.beforeUpload(files, fileList)
      await this.uploading(files, fileList)
    },
    see(i) {
      if (Filetype(i.url) == 4) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + i.url
        )
      } else {
        this.info = {
          type: Filetype(i.url),
          url: i.url,
          title: i.title || i.origin_name,
        }
        this.$refs.FileSee.visible = true
      }
    },
    //文件类型请求
  },
}
</script>
<style lang="less" scoped>
.uploadbox {
  .cbown {
    display: flex;
    align-items: center;
  }

  .clearbox {
    overflow: hidden;

    .input {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      label {
        font-size: 14px;
        text-align: right;
        color: #333;
      }
    }

    .btn {
      position: relative;
      border: 1px solid #1d8bfe;
      display: flex;
      align-items: center;
      width: 88px;
      height: 36px;
      border-radius: 4px;
      justify-content: center;
      color: #1d8bfe;
      cursor: pointer;
      transition-duration: 500ms;

      &:hover {
        background: #03a9f4;
        color: #fff;
      }

      span {
        margin-left: 4px;
      }

      input {
        opacity: 0;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }

  .table tbody td {

    // height: 64px;
    .title {
      width: 100%;
      line-height: 24px;
      word-wrap: break-word;
      white-space: normal;
      word-break: break-all;
      display: flex;
      align-items: center;

      .norap {
        flex: 1;
        max-width: 390px;
      }
    }
  }

  .table {
    .editing {
      opacity: 0.4;
    }

    .see {
      position: relative;
      display: inline-block;

      .pimg {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .fir {
        z-index: 999;
      }

      img {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
  }
}
</style>
<style lang="less">
.delete .anticon-delete {
  display: none;
}

.selectbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
